"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCMA = void 0;
var contentful_management_1 = require("contentful-management");
var react_1 = require("react");
var useSDK_1 = require("./useSDK");
/**
 * React hook returning a CMA plain client instance.
 * Must be used in the `SDKProvider` component. Will throw error, if called outside of `SDKProvider`.
 */
function useCMA() {
    var sdk = (0, useSDK_1.useSDK)();
    var cma = (0, react_1.useMemo)(function () {
        var _a;
        return (0, contentful_management_1.createClient)({ apiAdapter: sdk.cmaAdapter }, {
            type: 'plain',
            defaults: {
                environmentId: (_a = sdk.ids.environmentAlias) !== null && _a !== void 0 ? _a : sdk.ids.environment,
                spaceId: sdk.ids.space,
                organizationId: sdk.ids.organization,
            },
        });
    }, [sdk]);
    return cma;
}
exports.useCMA = useCMA;
